// extracted by mini-css-extract-plugin
module.exports = {"select-loader":"loadingCard_select-loader__1fnWT","select-multi-loader":"loadingCard_select-multi-loader__1c_sx"};